class DropdownItem {
  constructor(
    title,
    actionOrChildren,
    isGroup,
    noClose,
    isNote,
    isDisabled,
    requiresConfirmation,
    searchTerm,
    hasSearch,
    isLoading,
  ) {
    this._isDivider = !actionOrChildren;
    this._title = title;
    this._isGroup = isGroup;
    this._noClose = noClose;
    this._isNote = isNote;
    this._isDisabled = isDisabled;
    this._requiresConfirmation = requiresConfirmation;
    this._searchTerm = searchTerm;
    this._hasSearch = hasSearch;
    this._isLoading = isLoading;
    if (Array.isArray(actionOrChildren)) {
      this._children = actionOrChildren;
    } else {
      this._action = actionOrChildren;
    }
  }

  static dropdownWithConfirmation(title, action, isDisabled, isLoading) {
    return new DropdownItem(
      title,
      action,
      null,
      false,
      null,
      isDisabled,
      true,
      null,
      null,
      isLoading,
    );
  }

  static dropdown(title, children, isDisabled, searchTerm) {
    if (children.length === 0) {
      // exclude empty dropdowns
      return null;
    }
    return new DropdownItem(
      title,
      children,
      null,
      isDisabled,
      null,
      isDisabled,
      null,
      searchTerm,
    );
  }

  // this is used for submenus with search
  static dropdownWithSearch(title, children, isDisabled, searchTerm) {
    if (children.length === 0) {
      // exclude empty dropdowns
      return null;
    }
    return new DropdownItem(
      title,
      children,
      null,
      isDisabled,
      null,
      isDisabled,
      null,
      searchTerm,
      true,
    );
  }

  static group(title, children) {
    return new DropdownItem(title, children, true);
  }

  static action(title, action, noClose = false, searchTerm) {
    return new DropdownItem(
      title,
      action,
      false,
      noClose,
      null,
      null,
      null,
      searchTerm,
    );
  }

  static divider() {
    return new DropdownItem(null);
  }

  static note(note) {
    return new DropdownItem(note, null, false, null, true);
  }

  title() {
    return this._title;
  }

  hasChildren() {
    return !!this._children;
  }

  hasAction() {
    return !!this._action;
  }

  children() {
    return this._children;
  }

  onAction(e) {
    this._action(e);
  }

  isGroup() {
    return this._isGroup && !!this._children;
  }

  isNoClose() {
    return this._noClose;
  }

  isDisabled() {
    return this._isDisabled;
  }

  isDivider() {
    return this._isDivider && !this._isNote;
  }

  isNote() {
    return this._isNote;
  }

  searchTerm() {
    return this._searchTerm;
  }

  hasSearch() {
    return this._hasSearch && !!this._children;
  }

  requiresConfirmation() {
    return this._requiresConfirmation;
  }

  isLoading() {
    return this._isLoading;
  }
}

export default DropdownItem;
